import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import cn from 'classnames';
import { swiffyslider } from 'swiffy-slider';

var styles = {"dots":"index-module_dots__cE5oF","dot":"index-module_dot__5zFJE","dot--active":"index-module_dot--active__8P3z9","dot--more":"index-module_dot--more__UR1gB"};

const MAX_DOTS = 10;
const getDotsDescriptor = (imageCount, current) => {
    const page = Math.floor(current / MAX_DOTS);
    const pages = Math.ceil(imageCount / MAX_DOTS);
    const dots = Math.min(imageCount - page * MAX_DOTS, MAX_DOTS);
    return { dots, page, pages };
};
const Dots = ({ imageCount, current, }) => {
    const { dots, page, pages } = getDotsDescriptor(imageCount, current);
    if (imageCount < 2) {
        return null;
    }
    return (jsx("ul", { className: styles['dots'], children: Array.from({ length: dots }).map((_, i) => (jsx("li", { className: cn(styles['dot'], {
                [styles['dot--active']]: current % MAX_DOTS === i,
                [styles['dot--more']]: (i === 0 && page > 0) || (i === MAX_DOTS - 1 && page < pages - 1),
            }) }, i))) }));
};

var classes = {"slider":"index-module_slider__7H1hz","show-buttons":"index-module_show-buttons__6Rg4Q","hide-buttons":"index-module_hide-buttons__BGzHG","withDots":"index-module_withDots__wI362"};

// Taken from the Swiffy documentation site
const getVisibleSlides = (sliderElement) => {
    const container = sliderElement.querySelector('.slider-container');
    if (container) {
        //We are using a grid layout and the slides left and right properties include the width of the gap, so when comparing with container width add a gap for each side of the slide gap.
        const gapWidth = Number.parseInt(window.getComputedStyle(container).columnGap);
        const slides = Array.from(container.children);
        return slides.find((slide) => {
            const slideScrollLeftPosition = slide.getBoundingClientRect().left -
                container.getBoundingClientRect().left;
            const slideScrollRightPosition = slideScrollLeftPosition + slide.offsetWidth - gapWidth;
            return (slideScrollLeftPosition >= 0 &&
                slideScrollRightPosition <= container.offsetWidth);
        });
    }
};
const Swiffy = ({ listItems, itemCount, onChange, currentIndex, onError, showButtons, withDots = false, overlayElement, cssClass, labelArrows, onPrevButtonClick, onNextButtonClick, }) => {
    const swiffyInstance = useRef(null);
    const onSlideChange = useCallback(() => {
        if (swiffyInstance.current) {
            try {
                const swiffyDom = swiffyInstance.current;
                const slides = getVisibleSlides(swiffyDom);
                const indexFromDataset = slides?.dataset['index'];
                if (indexFromDataset) {
                    const index = Number.parseInt(indexFromDataset);
                    onChange?.(index);
                }
            }
            catch (e) {
                console.error(e);
                onError?.(e, { note: 'Error in Swiffy component.' });
            }
        }
    }, [onChange, onError]);
    //On change listener:
    useEffect(() => {
        if (swiffyInstance.current) {
            const swiffyDom = swiffyInstance.current;
            swiffyslider.onSlideEnd(swiffyDom, onSlideChange);
        }
    }, [onSlideChange]);
    //Init library:
    useEffect(() => {
        if (swiffyInstance.current) {
            const swiffyDom = swiffyInstance.current;
            swiffyslider.initSlider(swiffyDom);
        }
    }, []);
    //Slide to implementation using prop
    useEffect(() => {
        if (swiffyInstance.current) {
            swiffyslider.slideTo(swiffyInstance.current, currentIndex);
        }
    }, [currentIndex]);
    return (jsxs(Fragment, { children: [jsxs("div", { className: cn('swiffy-slider', classes.slider, 'slider-nav-touch', 'slider-nav-visibile', { [classes.withDots]: withDots }, cssClass), ref: swiffyInstance, children: [jsx("ul", { className: "slider-container", children: listItems }), overlayElement, jsxs("div", { id: "buttons-container", className: listItems.length > 1 && showButtons
                            ? classes['show-buttons']
                            : classes['hide-buttons'], children: [jsx("button", { type: "button", className: "slider-nav", "aria-label": labelArrows.left, onClick: onPrevButtonClick }), jsx("button", { type: "button", className: "slider-nav slider-nav-next", "aria-label": labelArrows.right, onClick: onNextButtonClick })] })] }), withDots && (jsx(Dots, { imageCount: itemCount ?? listItems.length, current: currentIndex }))] }));
};

export { Swiffy as Carousel };
//# sourceMappingURL=index.js.map
